import { useState } from 'react';
import { onFavoriteContent } from '../../../../../modules/Disciplines/queries/contentActions';
import { formatTime } from '../../../../commom/formatTime';
import { Button } from '../../../atoms/Button';
import { Tag, TagVariant } from '../../../atoms/Tag';
import { Typography } from '../../../molecules/Typography';
import { useNewContentCardContext } from '../useNewContentCardContext';
import { IconFav } from '../variants';

interface INewContentCardFooterProps {
  isFavorite: boolean;
  hideFavoriteButton?: boolean;
  incidence?: number;
  teacher?: string;
  duration?: number | string;
  materialType?: string;
  lessonType?: string;
  correctAnswersPercentage?: number;
  onChangeFavorite?: (value: boolean, contentId: string) => void;
}

export function NewContentCardFooter({
  isFavorite,
  hideFavoriteButton = false,
  incidence,
  teacher,
  duration,
  materialType,
  correctAnswersPercentage,
  lessonType,
  onChangeFavorite,
}: INewContentCardFooterProps) {
  const { contentId, contentType } = useNewContentCardContext();
  const [_isFavorite, setIsFavorite] = useState(isFavorite);
  const [isLoadingFavorite, setIsLoadingFavorite] = useState(false);

  function getMaterialType(type: string) {
    const typesMap = {
      workbook: 'Apostila',
      mindmap: 'Mapa mental',
    };

    return typesMap[type as keyof typeof typesMap] || '';
  }

  async function handleFavorite() {
    if (!contentId) return console.log('Content id not found');

    let category;
    if (contentType === 'material') {
      category = materialType === 'workbook' ? 'apostila' : materialType;
    } else {
      category = contentType;
    }

    if (!category) return console.log('Category not found');
    const targetType = contentType.charAt(0).toUpperCase() + contentType.slice(1);

    const body = {
      category: category.replaceAll('_', '').toLowerCase(),
      targetId: contentId,
      targetType: targetType,
    };

    setIsLoadingFavorite(true);
    await onFavoriteContent(body);

    setIsFavorite(!isFavorite);
    setIsLoadingFavorite(false);

    onChangeFavorite && onChangeFavorite(!isFavorite, contentId);
  }

  const textClassName =
    'text-mono-color-darker transition delay-100 ease-in-out group-hover:text-card-color-default';

  return (
    <div className='flex items-center justify-between gap-sm'>
      {contentType === 'lesson' && (
        <div className='flex items-center gap-sm'>
          {duration && (
            <Typography size='small' className={textClassName}>
              {typeof duration === 'number' ? formatTime(duration) : duration}
            </Typography>
          )}
          {teacher && (
            <Typography size='small' className={textClassName}>
              {teacher}
            </Typography>
          )}
          {incidence && (
            <Tag variant={`incidencia${incidence}` as TagVariant}>
              {`Incidência ${incidence}`}
            </Tag>
          )}
          {lessonType && (
            <Tag variant='primary'>
              {lessonType}
            </Tag>
          )}
        </div>
      )}

      {(contentType === 'exercise' || contentType === 'material') && (
        <div className='flex items-center gap-sm'>
          {materialType && (
            <Typography size='small' className={textClassName}>
              {getMaterialType(materialType)}
            </Typography>
          )}
          {correctAnswersPercentage !== undefined && (
            <Typography size='small' className={textClassName}>
              {correctAnswersPercentage}% de acertos
            </Typography>
          )}
        </div>
      )}

      {!hideFavoriteButton && (
        <Button
          variant='text'
          className='p-0'
          loading={isLoadingFavorite}
          LeftIcon={'star'}
          iconVariant='rounded'
          classNameIcon={IconFav({
            type: _isFavorite ? 'favorite' : 'notFavorite',
          })}
          iconType='material'
          onlyIcon
          onClick={(e) => {
            e.stopPropagation();
            handleFavorite();
          }}
        />
      )}
    </div>
  );
}
